import { InvoiceReportController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the report for the given invoice.
 * @example
 * ```html
 * <salaxy-invoice-report invoice="$ctrl.currentInvoice""></salaxy-invoice-report>
 * ```
 */
export class InvoiceReport extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The invoice for the report. */
      invoice: "<",
      /** If true, uses the current style of the site. The default value is false. */
      applySiteStyles: "<",
      /** The language for report*/
      lang: "<"
    };

    /** Uses the InvoiceReportController */
    public controller = InvoiceReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/invoices/InvoiceReport.html";

}
